import { bootstrapApplication } from '@angular/platform-browser';
import './app/core/config/ng-select-global.config';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err: any) => console.error(err));
